import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { useThemePreference } from '@/app/themePreference';

/** One-click light/dark control; the profile menu still exposes system mode. */
export function ThemeToggle() {
  const { resolvedTheme, setPreference } = useThemePreference();
  const next = resolvedTheme === 'dark' ? 'light' : 'dark';
  const label = `Switch to ${next} mode`;

  return (
    <Tooltip title={label}>
      <IconButton aria-label={label} onClick={() => setPreference(next)} sx={{ width: 44, height: 44 }}>
        {resolvedTheme === 'dark' ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
